import { DataTableComponent } from './../data-table/data-table.component';
import { ChooseDataModalComponent } from './../choose-data-modal/choose-data-modal.component';
import { VariazioneAccessiModalComponent } from './../variazione-accessi-modal/variazione-accessi-modal.component';
import { RequestBuilder } from './../classes/request-builder';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ICommessa } from '../interfaces/ICommessa';
import { Loading } from '../utils/loading';
import { CommessaService } from '../services/commessa.service';
import { finalize } from 'rxjs/operators';
import * as Enum from '../utils/enums';
import { AccessiService } from '../services/accessi.service';
import { ICantiere } from '../interfaces/ICantiere';
import { IMezzo } from '../interfaces/IMezzo';
import { IPersona } from '../interfaces/IPersona';
import { AccessiModalComponent } from '../accessi-modal/accessi-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AlertUtil } from '../utils/alert-util';
import { IAccesso } from '../interfaces/IAccesso';
import * as FileSaver from 'file-saver';
import * as Constants from '../utils/constants';
import * as Moment from 'moment';
import { IEsecutore } from '../interfaces/IEsecutore';
import { PersoneService } from '../services/persone.service';
import { MezziService } from '../services/mezzi.service';
import { AggiudicatarioService } from '../services/aggiudicatario.service';
import { CommessaModalComponent } from '../commessa-modal/commessa-modal.component';

@Component({
  selector: 'app-accessi',
  templateUrl: './accessi.component.html',
  styleUrls: ['./accessi.component.css'],
})
export class AccessiComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel;

  isEsecutore: boolean = false; //determines whether the user logged is esecutore
  isAggiudicatario: boolean = false; //determines whether the user logged is aggiudicatario
  isPrefettura: boolean = false; //determines whether the user logged is prefettura
  isAffidatario: boolean = false; //determines whether the user logged is affidatario

  /**
   * Array usati per popolare le tabelle
   */
  commesse: any[];
  cantieri: any[];
  mezzi: any[];
  persone: any[];
  siti: any[];

  /**
   * Commessa e cantiere selezionati
   */
  commessaSelected: ICommessa;
  cantiereSelected: ICantiere;

  cantierePersoneTableSelectedItem: any; // persona selected item
  cantiereMezziTableSelectedItem: any; // mezzo selected item
  DTT = Enum.DATA_TABLE_TYPE_ENUM; // export enum for html
  L = Loading; // export loading for html
  qrUrl: string = ''; // url del qr code

  esecutoriWithoutAccessi: string = ''; // string esecutori senza accessi

  @ViewChild('dtCantieri') dtCantieri: DataTableComponent;
  @ViewChild('dtMezzi') dtMezzi: DataTableComponent;
  @ViewChild('dtPersone') dtPersone: DataTableComponent;

  constructor(
    private commessaService: CommessaService,
    private accessiService: AccessiService,
    private aggiudicatarioService: AggiudicatarioService,
    private personeService: PersoneService,
    private mezziService: MezziService,
    public dialogService: DialogService,
    private translate: TranslateService,
    private alertUtil: AlertUtil
  ) {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE);
    this.checkUserRole(userRole);
  }

  ngOnInit() {
    setTimeout(() => {
      this.getAllCommesse();
      this.getAllSiti();
    }, 0);
  }

  /**
   * check role of user logged
   */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isEsecutore = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true;
    } else if (
      userRole == Enum.USER_TYPE_ENUM.PREFETTURA ||
      userRole == Enum.USER_TYPE_ENUM.DL
    ) {
      this.isPrefettura = true;
    } else if (
      userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO ||
      userRole == Enum.USER_TYPE_ENUM.GVS ||
      userRole == Enum.USER_TYPE_ENUM.CSE
    ) {
      this.isAffidatario = true;
    }
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true;
    let reqBuilder = new RequestBuilder({});
    this.commessaService.getAllCommesse(reqBuilder).pipe(
      finalize(() => {
        Loading.isLoading = false;
      })
    ).subscribe((response) => {
      if (response.data) {
        this.commesse = response.data;
      } else if (response.error) {
        let errorKey = 'LBL_ERROR_' + response.error.Code;
        this.alertUtil.showErrorAlert(errorKey);
        console.log('ERROR: ' + response.error.Stack);
      } else {
        this.alertUtil.showErrorAlert(
          'LBL_SERVER_ERROR_GENERIC',
          { error: response.Message }
        );
      }
    },
      (error) => {
        let errorKey = 'LBL_HTTP_ERROR_0';
        if (error.status) {
          errorKey = 'LBL_HTTP_ERROR_' + error.status;
        }
        this.alertUtil.showErrorAlert(errorKey);
      }
    );
  }

  /**
   * restituisce l'elenco dei siti
   */
  private getAllSiti() {
    this.accessiService.getAllSiti(new RequestBuilder({})).pipe(
      finalize(() => {
        Loading.isLoading = false;
      })).subscribe((response) => {
        if (response.data) {
          this.siti = response.data;
        } else if (response.error) {
          let errorKey = 'LBL_ERROR_' + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log('ERROR: ' + response.error.Stack);
        } else {
          this.alertUtil.showErrorAlert(
            'LBL_SERVER_ERROR_GENERIC',
            {
              error: response.Message,
            }
          );
        }
      },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * open commessa modal
   * @param commessa
   */
  openCommessaModal(commessa?: ICommessa) {
    Loading.isLoading = true;
    //get all aggiudicatari
    this.aggiudicatarioService.getAllAggiudicatari().pipe(
      finalize(() => {
        Loading.isLoading = false;
      })
    ).subscribe((response) => {
      if (response.data) {
        //get header translation
        this.translate
          .get(['LBL_NEW_COMMESSA', 'LBL_UPDATE_COMMESSA'])
          .subscribe((res) => {
            //open commessa modal
            let commessaModal = this.dialogService.open(CommessaModalComponent, {
              data: {
                commessa: commessa,
                aggiudicatari: response.data,
              },
              header: commessa
                ? res['LBL_UPDATE_COMMESSA']
                : res['LBL_NEW_COMMESSA'],
              width: '50%',
            }
            );

            // refresh commesse when modal is closed and newCommessa is created
            commessaModal.onClose.subscribe(
              (newCommessa) => {
                if (newCommessa) {
                  this.getAllCommesse();
                }
              }
            );
          });
      } else if (response.error) {
      } else {
        this.alertUtil.showErrorAlert(
          'LBL_SERVER_ERROR_GENERIC',
          { error: response.Message }
        );
      }
    },
      (error) => {
        let errorKey = 'LBL_HTTP_ERROR_0';
        if (error.status) {
          errorKey = 'LBL_HTTP_ERROR_' + error.status;
        }
        this.alertUtil.showErrorAlert(errorKey);
      }
    );
  }

  /**
   * callback fired when one commessa row is selected
   * @param commessa
   */
  onCommessaRowSelected(commessa: ICommessa) {
    this.commessaSelected = null;
    this.cantiereSelected = null;
    this.commessaSelected = commessa;

    Loading.isLoading = true;
    let requestBuilder = new RequestBuilder({ Id: commessa.Id }, [
      'Cantieri',
    ]);
    this.commessaService.getCommessaData(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false;
    })
    ).subscribe(
      (response) => {
        if (response.data) {
          //Resets sort, filter and paginator state.
          this.dtCantieri.resetTable();
          this.cantieri = response.data.Cantieri;
        } else if (response.error) {
          let errorKey = 'LBL_ERROR_' + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log('ERROR: ' + response.error.Stack);
        } else {
          this.alertUtil.showErrorAlert(
            'LBL_SERVER_ERROR_GENERIC',
            { error: response.Message }
          );
        }
      },
      (error) => {
        let errorKey = 'LBL_HTTP_ERROR_0';
        if (error.status) {
          errorKey = 'LBL_HTTP_ERROR_' + error.status;
        }
        this.alertUtil.showErrorAlert(errorKey);
      }
    );
  }

  /**
   * callback fired when one commessa row is unselected
   */
  onCommessaRowUnselected() {
    this.commessaSelected = null;
    this.cantiereSelected = null;
  }

  /**
   * callback fired when one cantiere row is selected
   * @param commessa
   */
  onCantiereRowSelected(cantiere: ICantiere) {
    this.cantiereSelected = cantiere;

    Loading.isLoading = true;
    let requestBuilder = new RequestBuilder({ Id: cantiere.Id });
    this.accessiService.getCantiereData(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false;
    })
    ).subscribe(
      (response) => {
        if (response.data) {
          //Resets sort, filter and paginator state.
          if (this.dtMezzi) {
            this.dtMezzi.resetTable();
          }
          if (this.dtPersone) {
            this.dtPersone.resetTable();
          }
          this.mezzi = response.data.Mezzi;
          this.persone = response.data.Persone;
        } else if (response.error) {
          let errorKey = 'LBL_ERROR_' + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log('ERROR: ' + response.error.Stack);
        } else {
          this.alertUtil.showErrorAlert(
            'LBL_SERVER_ERROR_GENERIC',
            { error: response.Message }
          );
        }
      },
      (error) => {
        let errorKey = 'LBL_HTTP_ERROR_0';
        if (error.status) {
          errorKey = 'LBL_HTTP_ERROR_' + error.status;
        }
        this.alertUtil.showErrorAlert(errorKey);
      }
    );
  }

  /**
   * callback fired when one cantiere row is unselected
   */
  onCantiereRowUnselected() {
    this.cantiereSelected = null;
  }

  /**
   * callback fired when one mezzo row is selected
   * @param commessa
   */
  onMezzoRowSelected(mezzo: IMezzo) {
    Loading.isLoading = true;
    let jsonPayload = {
      Mezzo: {
        Id: mezzo.Id
      },
      Commessa: {
        Cantieri: [{ Id: this.cantiereSelected.Id }]
      }
    };
    let requestBuilder = new RequestBuilder(jsonPayload, ['Accessi.Sito']);
    this.accessiService.getAccessiMezzo(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false;
    })
    ).subscribe(
      (response) => {
        if (response.data) {
          this.openAccessiModal(
            response.data,
            mezzo,
            this.siti,
            Enum.DATA_TABLE_TYPE_ENUM.MEZZO
          );
        } else if (response.error) {
          let errorKey = 'LBL_ERROR_' + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log('ERROR: ' + response.error.Stack);
        } else {
          this.alertUtil.showErrorAlert(
            'LBL_SERVER_ERROR_GENERIC',
            { error: response.Message }
          );
        }
      },
      (error) => {
        let errorKey = 'LBL_HTTP_ERROR_0';
        if (error.status) {
          errorKey = 'LBL_HTTP_ERROR_' + error.status;
        }
        this.alertUtil.showErrorAlert(errorKey);
      }
    );
  }

  /**
   * callback fired when one mezzo row is unselected
   */
  onMezzoRowUnselected() {
    //NON UTILIZZATO
  }

  /**
   * callback fired when one persona row is selected
   * @param commessa
   */
  onPersonaRowSelected(persona: IPersona) {
    Loading.isLoading = true;
    let jsonPayload = {
      Persona: {
        Id: persona.Id
      },
      Commessa: {
        Cantieri: [{ Id: this.cantiereSelected.Id }]
      }
    };
    let requestBuilder = new RequestBuilder(jsonPayload, [
      'Accessi.Sito',
    ]);
    this.accessiService
      .getAccessiPersona(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            this.openAccessiModal(
              response.data,
              persona,
              this.siti,
              Enum.DATA_TABLE_TYPE_ENUM.PERSONA
            );
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert(
              'LBL_SERVER_ERROR_GENERIC',
              { error: response.Message }
            );
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * callback fired when one persona row is unselected
   */
  onPersonaRowUnselected() {
    //NON UTILIZZATO
  }

  /**
   * Open modal of accessi of one persona or one mezzo
   * @param responseData
   */
  openAccessiModal(responseData: any, parent: any, siti: any, parentType: string) {
    let riferimentoTxt =
      parentType === Enum.DATA_TABLE_TYPE_ENUM.PERSONA
        ? parent.Cognome + ' ' + parent.Nome
        : parent.Marca + ' - ' + parent.Modello;
    this.translate
      .get('MENU_ACCESSI_', { riferimento: riferimentoTxt })
      .subscribe((res) => {
        let ref = this.dialogService.open(AccessiModalComponent, {
          data: {
            data: responseData,
            parent: parent,
            siti: siti,
            parentType: parentType,
            cantiereSelected: this.cantiereSelected,
          },
          header: res,
          width: '90%',
        });
      });
  }

  /**
   * callback fired when qr code of one persona is clicked
   * @param commessa
   */
  onPersonaQRCode(persona: IPersona) {
    //Mansione se c'e' altrimenti qualifica
    let tipo = persona.Mansione ? persona.Mansione : persona.Qualifica;

    Loading.isLoading = true;
    //Creazione della richiesta
    let requestBuilder = new RequestBuilder({
      Expiration: this.commessaSelected.Data_fine_lavori ? this.commessaSelected.Data_fine_lavori : '9999-12-31 23:59:59',
      Code: persona.Codice_fiscale,
      Type: tipo,
    });
    this.accessiService
      .getQRCode(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          //Remove row selected
          this.cantierePersoneTableSelectedItem = [];

          //Torna un byte array
          if (response.data) {
            //Settare qrUrl per mostrare il qrCode
            this.qrUrl = response.data;
            //Apertura dell'overlay panel
            this.op.toggle(event);
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert(
              'LBL_SERVER_ERROR_GENERIC',
              { error: response.Message }
            );
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * callback fired when qr code of one mezzo is clicked
   * @param commessa
   */
  onMezzoQRCode(mezzo: IMezzo) {
    //Tipo se c'e' altrimenti definizione
    let tipo = mezzo.Tipo ? mezzo.Tipo : mezzo.Definizione;

    Loading.isLoading = true;
    //Creazione della richiesta
    let requestBuilder = new RequestBuilder({
      Expiration: this.commessaSelected.Data_fine_lavori ? this.commessaSelected.Data_fine_lavori : '9999-12-31 23:59:59',
      Code: mezzo.Targa,
      Type: tipo,
    });
    this.accessiService
      .getQRCode(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          //Remove row selected
          this.cantiereMezziTableSelectedItem = [];

          //Torna un byte array
          if (response.data) {
            //Settare qrUrl per mostrare il qrCode
            this.qrUrl = response.data;
            //Apertura dell'overlay panel
            this.op.toggle(event);
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert(
              'LBL_SERVER_ERROR_GENERIC',
              { error: response.Message }
            );
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * click variazione accessi btn
   * @param cantiere cantiere selected
   */
  onClickVariazioneAccessi(cantiere: ICantiere) {
    let requestBuilder = new RequestBuilder({ Id: cantiere.Id });
    this.accessiService.fetchVariazioneAccessi(requestBuilder).subscribe(
      (response) => {
        if (response.data) {
          this.openVariazioneAccessiModal(response.data);
        } else if (response.error) {
          let errorKey = 'LBL_ERROR_' + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log('ERROR: ' + response.error.Stack);
        } else {
          this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
            error: response.Message,
          });
        }
      },
      (error) => {
        let errorKey = 'LBL_HTTP_ERROR_0';
        if (error.status) {
          errorKey = 'LBL_HTTP_ERROR_' + error.status;
        }
        this.alertUtil.showErrorAlert(errorKey);
      }
    );
  }

  /**
   * Open modal of list variazione accessi
   * @param responseData
   */
  openVariazioneAccessiModal(variazioneAccessi: IAccesso[]) {
    this.translate.get('MENU_SETTIMANALI').subscribe((res) => {
      let ref = this.dialogService.open(VariazioneAccessiModalComponent, {
        data: {
          variazioneAccessi: variazioneAccessi,
        },
        header: res,
        width: '85%',
      });
    });
  }

  /**
   * click button for download all accessi qrcode
   */
  downloadQrCodeAccessi() {
    Loading.isLoading = true;
    let requestBuilder = new RequestBuilder({
      Id: this.cantiereSelected.Id,
    });
    this.accessiService.getQRCodeZip(requestBuilder).pipe(
      finalize(() => {
        Loading.isLoading = false;
      })
    )
      .subscribe(
        (response) => {
          if (response && response['error'] == null) {
            this.downloadFile(response, Enum.FILE_TYPE_ENUM.ZIP, "QRCodeAccessi")
            // this.alertUtil.showAlert(
            //   'LBL_QRCODE_ACCESSI_DOWNLOAD',
            //   { downloadMessage: response.data }
            // );
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert(
              'LBL_SERVER_ERROR_GENERIC',
              { error: response.Message }
            );
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * download zip file
   * @param response response from service
   * @param type type of file
   * @param name name of file
   */
  downloadFile(response: any, type: string, name: string) {
    let fileType = '';
    let stringDecoded: any;
    //switch type of file and set fileType and string decoded
    switch (type) {
      case Enum.FILE_TYPE_ENUM.XLS:
        fileType = 'application/vnd.ms-excel;charset=utf-8';
        stringDecoded = this.s2ab(atob(response));
        break;
      case Enum.FILE_TYPE_ENUM.XLSX:
        fileType =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
        stringDecoded = this.s2ab(atob(response));
        break;
      case Enum.FILE_TYPE_ENUM.DOC:
      case Enum.FILE_TYPE_ENUM.DOCX:
        fileType = 'application/msword;charset=utf-8';
        stringDecoded = this.s2ab(atob(response));
        break;
      case Enum.FILE_TYPE_ENUM.PPT:
      case Enum.FILE_TYPE_ENUM.PPTX:
        fileType = 'application/vnd.ms-powerpoint;charset=utf-8';
        stringDecoded = this.s2ab(atob(response));
        break;
      case Enum.FILE_TYPE_ENUM.ZIP:
        fileType = 'application/zip';
        stringDecoded = this.s2ab(atob(response.data));
        break;
      default: //case Enum.FILE_TYPE_ENUM.TXT:
        fileType = 'text/plain;charset=utf-8';
        stringDecoded = atob(response);
    }

    let blob = new Blob([stringDecoded], {
      type: fileType,
    });
    FileSaver.saveAs(blob, name);
  }

  private s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  /**
   * Open modal for the choose of data
   */
  openChooseDataModal() {
    this.translate.get('LBL_WEEK_ACCESSI').subscribe((res) => {
      let ref = this.dialogService.open(ChooseDataModalComponent, {
        header: res,
        width: '50%',
      });

      // refresh aggiudicatari when modal is closed and newAggiudicatario is created
      ref.onClose.subscribe((dataScelta) => {
        if (dataScelta) {
          let dataString = this.formatDateForSave(dataScelta);
          this.callGetAziendeWithoutAccessService(dataString);
        }
      });
    });
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue item value
   */
  formatDateForSave(dateValue: Date): string {
    return Moment(dateValue).format('YYYY-MM-DDTHH:mm:ss');
  }

  /**
   * click button for download accessi settimanali
   */
  downloadAccessiSettimanali(data: string) {
    Loading.isLoading = true;
    let requestBuilder = new RequestBuilder(
      {
        IdCantiere: this.cantiereSelected.Id,
        IdCommessa: this.commessaSelected.Id,
        FilterWeeklyDate: data,
      },
      ['Accessi.Sito']
    );
    this.accessiService.getAccessiSettimanali(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response && response['error'] == null) {
            this.downloadFile(
              response,
              Enum.FILE_TYPE_ENUM.XLSX,
              'AccessiSettimanali'
            );
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert(
              'LBL_SERVER_ERROR_GENERIC',
              { error: response.Message }
            );
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * get all aziende without accessi
   */
  callGetAziendeWithoutAccessService(data: string) {
    Loading.isLoading = true;
    let requestBuilder = new RequestBuilder({
      IdCantiere: this.cantiereSelected.Id,
      FilterWeeklyDate: data,
    });
    this.accessiService
      .getAziendeSenzaAccessi(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            let esecutoriArray: IEsecutore[] = response.data;
            if (esecutoriArray && esecutoriArray.length > 0) {
              esecutoriArray.forEach((esecutore) => {
                this.esecutoriWithoutAccessi +=
                  esecutore.Ragione_sociale + ' ';
              });
              this.alertUtil.showConfirmationAlert(
                'LBL_ESECUTORI_WITHOUT_ACCESSI_MSG',
                { esecutori: this.esecutoriWithoutAccessi },
                null,
                null,
                null,
                () => {
                  this.esecutoriWithoutAccessi = '';
                  this.downloadAccessiSettimanali(data);
                },
                () => {
                  this.esecutoriWithoutAccessi = '';
                }
              );
            } else {
              this.downloadAccessiSettimanali(data);
            }
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert(
              'LBL_SERVER_ERROR_GENERIC',
              { error: response.Message }
            );
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * callback fired when stop activity for mezzo is clicked
   * @param mezzo
   */
  onTerminaAttivitaMezzo(mezzo: IMezzo) {
    // ask for stop activity confirmation
    this.alertUtil.showConfirmationAlert(
      'LBL_STOP_ACTIVITY_CONFIRMATION',
      null,
      null,
      null,
      null,
      () => {
        Loading.isLoading = true;
        // Modifica del 26/11/2024 - Aggiunto IdCantiere al payload del Servizio
        let requestBuilder = new RequestBuilder({ Id: mezzo.Id, IdCantiere: this.cantiereSelected.Id });
        this.mezziService
          .terminaAttivita(requestBuilder)
          .pipe(
            finalize(() => {
              Loading.isLoading = false;
            })
          )
          .subscribe(
            (response) => {
              if (response.data) {
                // refresh accessi for cantiere
                this.alertUtil.showAlert(
                  'LBL_STOP_ACTIVITY_SUCCESS',
                  null,
                  null,
                  null,
                  () => {
                    this.onCantiereRowSelected(
                      this.cantiereSelected
                    );
                  }
                );
              } else if (response.error) {
                let errorKey =
                  'LBL_ERROR_' + response.error.Code;
                this.alertUtil.showErrorAlert(errorKey);
                console.log('ERROR: ' + response.error.Stack);
              } else {
                this.alertUtil.showErrorAlert(
                  'LBL_SERVER_ERROR_GENERIC',
                  { error: response.Message }
                );
              }
            },
            (error) => {
              let errorKey = 'LBL_HTTP_ERROR_0';
              if (error.status) {
                errorKey = 'LBL_HTTP_ERROR_' + error.status;
              }
              this.alertUtil.showErrorAlert(errorKey);
            }
          );
      }
    );
  }

  /**
   * callback fired when stop activity for persona is clicked
   * @param persona
   */
  onTerminaAttivitaPersona(persona: IPersona) {
    // ask for stop activity confirmation
    this.alertUtil.showConfirmationAlert(
      'LBL_STOP_ACTIVITY_CONFIRMATION',
      null,
      null,
      null,
      null,
      () => {
        Loading.isLoading = true;
        // Modifica del 26/11/2024 - Aggiunto IdCantiere al payload del Servizio
        let requestBuilder = new RequestBuilder({ Id: persona.Id, IdCantiere: this.cantiereSelected.Id });
        this.personeService
          .terminaAttivita(requestBuilder)
          .pipe(
            finalize(() => {
              Loading.isLoading = false;
            })
          )
          .subscribe(
            (response) => {
              if (response.data) {
                // refresh accessi for cantiere
                this.alertUtil.showAlert(
                  'LBL_STOP_ACTIVITY_SUCCESS',
                  null,
                  null,
                  null,
                  () => {
                    this.onCantiereRowSelected(
                      this.cantiereSelected
                    );
                  }
                );
              } else if (response.error) {
                let errorKey =
                  'LBL_ERROR_' + response.error.Code;
                this.alertUtil.showErrorAlert(errorKey);
                console.log('ERROR: ' + response.error.Stack);
              } else {
                this.alertUtil.showErrorAlert(
                  'LBL_SERVER_ERROR_GENERIC',
                  { error: response.Message }
                );
              }
            },
            (error) => {
              let errorKey = 'LBL_HTTP_ERROR_0';
              if (error.status) {
                errorKey = 'LBL_HTTP_ERROR_' + error.status;
              }
              this.alertUtil.showErrorAlert(errorKey);
            }
          );
      }
    );
  }

  /**
   * open new page with link address
   * @param commessa
   */
  goToGISPage(commessa: ICommessa) {
    let linkGIS = commessa.LinkGIS;
    if (
      linkGIS.indexOf('http://') == -1 &&
      linkGIS.indexOf('https://') == -1
    ) {
      linkGIS = 'http://' + linkGIS;
    }
    window.open(linkGIS, '_blank');
  }
}
